"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _css = _interopRequireDefault(require("@styled-system/css"));

var _system = _interopRequireDefault(require("../../../utils/system"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TableRow = (0, _system["default"])('tr')({
  label: 'TableRow'
}, (0, _css["default"])({
  boxSizing: 'border-box',
  color: 'inherit',
  display: 'table-row',
  outline: 0,
  verticalAlign: 'middle'
}), function (props) {
  return props.striped && (0, _css["default"])({
    '&:nth-of-type(odd)': {
      bg: 'gray.50'
    }
  });
}, function (props) {
  return props.hovered && (0, _css["default"])({
    '&:hover': {
      bg: 'gray.50'
    }
  });
});
TableRow.displayName = 'TableRow';
var _default = TableRow;
exports["default"] = _default;

//# sourceMappingURL=TableRow.js.map